import { useRef } from 'react'
import useKSWorkerDebugViewModel from './KSWorkerDebugViewModel'

const KSWorkerDebug = () => {
    
    const fileInputRef = useRef(null)
    const vm = useKSWorkerDebugViewModel()
    
    return (
        
        <div id="KSWorkerDebug" className="p-3 pt-0">
            
            <h4>Worker Debug</h4>
            
            <div
                className="relative mt-4 w-1/3 aspect-square mx-auto
                    bg-base-200 hover:bg-base-300/50 cursor-pointer rounded p-3"
                onClick={() => fileInputRef.current.click()}>
                <input
                    ref={fileInputRef}
                    className="hidden"
                    type="file"
                    onChange={vm.onFileChange} />
                <div className="absolute inset-0 flex items-center justify-center">
                    <p className="text-center text-sm">
                        {vm.file?.name ?? 'Select a PDF file'}
                    </p>
                </div>
            </div>
        
        </div>
        
    )
    
}

export default KSWorkerDebug
